<template>
  <el-container class="full-container" :class="currentTheme">
    <el-header
        height="120px">
      <div class="header-content">
        <div class="logo-container">
          <img src="../assets/logo.png" alt="Logo" class="logo">
        </div>
        <div class="title-container">
          <h1>大数据下的舆情风险监测</h1>
        </div>
        <!--切换主题的按钮-->
        <div class="theme-switch">
          <el-switch
            :value="isDarkTheme"
            active-color="#409EFF"
            inactive-color="#909399"
            :active-icon-class="'el-icon-moon'"
            :inactive-icon-class="'el-icon-sunny'"
            @change="handleThemeChange">
          </el-switch>
        </div>
      </div>
    </el-header>
    <el-container>
      <el-aside
          width="auto">
        <el-menu
          @select="handleMenuSelect"
          :default-active="activeIndex"
          mode="vertical"
          active-text-color="#41b883"
          background-color="revert"
          text-color="revert"
          :router="true">
<!--router	是否使用 vue-router 的模式，启用该模式会在激活导航时以 index 作为 path 进行路由跳转	boolean          -->
          <el-menu-item index="/data-table">
            <i class="el-icon-data-line"></i>
            <span>数据筛选展示</span>
          </el-menu-item>
          <el-menu-item index="/data-screen">
            <i class="el-icon-monitor"></i>
            <span>数据大屏展示</span>
          </el-menu-item>
          <el-menu-item index="/data-charts">
            <i class="el-icon-pie-chart"></i>
            <span>数据图表分析</span>
          </el-menu-item>
          <el-menu-item index="/data-audit">
            <i class="el-icon-document-checked"></i>
            <span>数据审查机制</span>
          </el-menu-item>
          <el-menu-item index="/data-import">
            <i class="el-icon-upload"></i>
            <span>数据导入</span>
          </el-menu-item>
        </el-menu>
      </el-aside>
      <el-main>
        <router-view></router-view>
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex'

export default {
  name: 'MyIndex',
  computed: {
    ...mapGetters(['currentTheme', 'isDarkTheme']),
    activeIndex() {
      return this.$route.path
    },
    ...mapState(['baseUrl'])
  },
  methods: {
    handleMenuSelect(indexPath){
      console.log(indexPath)
    },
    ...mapActions(['toggleTheme']),
    handleThemeChange(value) {
      this.toggleTheme(value)
      document.documentElement.classList.toggle("dark")
    }
  },
  created() {
    // 初始化时设置主题
    document.body.className = this.currentTheme
  },
  watch: {
    currentTheme(newTheme) {
      document.body.className = newTheme
    }
  }
}
</script>

<style>

.full-container {
  height: 100vh;
  width: 100vw;
}
.el-menu-item{
  color: revert;
}
.el-header {
  border-bottom: 1px solid #d3dce6;
}
.header-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}
.el-menu-item span{
  margin-right: 25px;
}
.logo {
  height: 80px;
}

.title-container {
  text-align: center;
}

.theme-switch {
  display: flex;
  align-items: center;
}

.el-header h1 {
  margin: 0;
  font-size: 28px;
  font-weight: bold;
}

.el-aside {
  text-align: left;
  border-right: 1px solid #d3dce6;
  //background-color: #fff;
}

.el-main {
  text-align: left;
}

body {
  margin: 0;
  padding: 0;
  overflow: auto;
}
.header-content{
  height: 100%;
}


</style>